$(document).ready(function() {
  $('#proceedButton').on('click', function() {
    
    var locationId = $('#locationDropdown').val(); // Get value from dropdown
    console.log("oocattt",locationId);
    localStorage.setItem('selectedLocationId', locationId); // Store in localStorage

    // Redirect to the desired URL with locationId as a query parameter
    window.location.href = '/collections/all?location=' + encodeURIComponent(locationId);
  });
});
